export const ConsultantBarometerQuestionPhrases: { [answerType: string]: string } = {
    // Change needed for IE
    Project: 'I feel my work at my client is challenging.',
    Growth: 'I feel that I can grow thanks to what I’m doing right now.',
    Network: 'I feel that I am in contact with or have access to people inside AE that can help me grow.',
    Rotation: 'Time to plan for a new adventure at one of our customers?'
};

export const RotationTermPhrases: { [rotationTerm: string]: string } = {
    Months_3: '3 months',
    Months_6: '6 months',
    Months_9: '9 months'
};
